"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _backgroundColors = _interopRequireDefault(require("../helpers/background-colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Nav =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Nav, _React$Component);

  function Nav() {
    _classCallCheck(this, Nav);

    return _possibleConstructorReturn(this, _getPrototypeOf(Nav).apply(this, arguments));
  }

  _createClass(Nav, [{
    key: "render",
    value: function render() {
      switch (this.props.style) {
        case Nav.styles.singleTier:
        case Nav.styles.twoTier:
          return this.tierRender();

        case Nav.styles.left:
          return this.leftNavRender();

        default:
          return null;
      }
    }
  }, {
    key: "tierRender",
    value: function tierRender() {
      var tier = 'one';

      if (this.props.style === Nav.styles.twoTier) {
        tier = 'two';
      }

      var klasses = "tier ".concat(tier, " ").concat(this.props.backgroundColor);
      return _react.default.createElement("nav", {
        className: klasses
      }, this.renderBrand(), _react.default.createElement("ul", {
        className: "nav navbar-nav"
      }, this.renderLinks()), this.props.children);
    }
  }, {
    key: "leftNavRender",
    value: function leftNavRender() {
      var navKlass = "split split-fixed bg-charcoal";
      return _react.default.createElement("nav", {
        "aria-label": "side navigation",
        className: navKlass
      }, _react.default.createElement("div", {
        className: "scroll-wrapper"
      }, _react.default.createElement("ul", {
        className: "nav nav-pills nav-stacked nav-charcoal"
      }, this.renderLinks()), this.props.children));
    }
  }, {
    key: "renderLinks",
    value: function renderLinks() {
      if (!this.props.links) {
        return null;
      }

      return this.props.links.map(function (l, index) {
        var klass = '';

        if (l.active) {
          klass += 'active';
        }

        return _react.default.createElement("li", {
          key: index,
          className: klass
        }, _react.default.createElement("a", {
          href: l.href
        }, l.text));
      });
    }
  }, {
    key: "renderBrand",
    value: function renderBrand() {
      if (!this.props.brand) {
        return null;
      }

      if (typeof this.props.brand === 'string') {
        return _react.default.createElement("div", {
          className: "branding"
        }, _react.default.createElement("a", {
          className: "navbar-text",
          href: "/"
        }, this.props.brand));
      } else {
        return _react.default.createElement("a", {
          className: "navbar-brand",
          href: "/"
        }, this.props.brand);
      }
    }
  }]);

  return Nav;
}(_react.default.Component);

Nav.styles = {};
var styles = ['singleTier', 'left', 'twoTier'];
styles.forEach(function (s) {
  Nav.styles[s] = s;
});
Nav.propTypes = {
  style: _propTypes.default.oneOf(styles),
  backgroundColor: _propTypes.default.oneOf(Object.values(_backgroundColors.default))
};
var _default = Nav;
exports.default = _default;